<template>
  <Select v-bind="$attrs" size="small">
    <template v-for="(slot, name) in $slots" #[name]="slotProps" v-bind:key="name">
      <component :is="slot" v-bind="slotProps" />
    </template>
    <template #dropdownicon v-if="!$slots.dropdownicon">
      <SortDownCenteredIcon />
    </template>
  </Select>
</template>

<script setup lang="ts">
import Select from 'primevue/select'
import type { SelectSlots } from 'primevue/select'
import SortDownCenteredIcon from '../Icons/SortDownCenteredIcon.vue'

defineSlots<Partial<SelectSlots>>()
</script>
<style>
.tw-bootstrap-override .p-select-label {
  font-size: 14px;
  line-height: 18px;
}
</style>
